/**
 * @flow
 */
'use strict';

export const frequencyCodes = [
{"code":"PRN"},
{"code":"ID"},
{"code":"once per day"},
{"code":"HS"},
{"code":"BID"},
{"code":"TID"},
{"code":"QID"},
{"code":"Q1H while awake"},
{"code":"Q2H while awake"},
{"code":"weekly"},
{"code":"every 2 weeks"},
]
